module.exports = __webpack_public_path__ + "media/images/mobile/home/tag_b-2e68973cebb1595a21c5e35ac6f1c064.png";